var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdCanceled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.47 20.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e20613;stroke-width:1.61px;}.cls-1,.cls-2,.cls-4{stroke:#e20613;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#fff;}.cls-3{font-size:9px;font-family:Montserrat-Bold, Montserrat;font-weight:700;}.cls-4{fill:none;stroke-width:2.41px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ELMARAD ikon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ELMARAD"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.8,
    y: 0.8,
    width: 101.87,
    height: 18.43,
    rx: 9.21,
    ry: 9.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.02,
    cy: 10.02,
    r: 9.21
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(34.6 13.02) scale(1.04 1)"
  }, "ELMARAD"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 6.12,
    y1: 6.12,
    x2: 13.91,
    y2: 13.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 13.91,
    y1: 6.12,
    x2: 6.12,
    y2: 13.91
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdCanceled);
export default __webpack_public_path__ + "static/media/prod-canceled.f2aace6a8de6e10ebc0318ab9fe79f92.svg";
export { ForwardRef as ReactComponent };